import useDashboard from "./dashboard";
import useProcess from "./process"
import useIndicator from "./indicators"

const useLegal = () => {
  return { useDashboard, useProcess, useIndicator };
};

export default useLegal;
